module.exports = require('./dist/input-slider.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-input-slider/index.js
// module id = 1012
// module chunks = 0